export default {
    // 款式状态
    DESIGN_STATUS_DRAFT: 0,
    DESIGN_STATUS_WAIT_BARGAIN: 1,
    DESIGN_STATUS_FACTORY_BARGAIN: 3,
    DESIGN_STATUS_CONFIRM_DESIGN: 4,

    // 轮播图位置
    BANNER_POSITION_POST: 1,
    BANNER_POSITION_INFO: 2,
    BANNER_POSITION_MATCH: 3,

    // 帖子状态
    POST_STATUS_DRAFT: -1,
    POST_STATUS_WAIT_AUTH: 0,
    POST_STATUS_REJECT: 2,
    POST_STATUS_PASS: 3,

    // 基准颜色横向长度
    COLOR_BASE_X: 87.65,
    // 基准颜色纵向长度
    COLOR_BASE_Y: 82.81,
    // 相机初始化视角
    CAMERA_FOV: 40,
    // 单次放大步进值
    STEP_CLICK_FOV: 3,
    // 滚轮缩放步进值
    STEP_WHEEL_FOV: 0.015
}
